import * as React from 'react';
import { Control, Form, Errors } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
import { DateTimePicker } from '@common/components';
import { VendorViewModel, TradeViewModel } from '@models/Vendor';
import { getDefaultErrorMessages, isDecimal } from '@common/validators';
import * as moment from 'moment';

export interface TradeOverridesComponentProperties {
  readonly vendorVM: VendorViewModel;
  readonly currentTrade: TradeViewModel;
  readonly reset: (currentTrade: TradeViewModel) => void;
  readonly updateVendorTrade: (vendorId: number, vendorTrade: TradeViewModel) => void;
}

export class TradeOverridesComponent extends React.Component<TradeOverridesComponentProperties> {
  componentWillMount() {
    this.reset();
  }

  componentWillReceiveProps(nextProps: TradeOverridesComponentProperties) {
    if (this.props.currentTrade !== nextProps.currentTrade) {
      this.reset(nextProps.currentTrade);
    }
  }

  reset = (trade?: TradeViewModel) => {
    const newTrade = trade ? trade : this.props.currentTrade;
    this.props.reset(newTrade);
  };

  /**
   * Require one hold date if other is present
   *
   * @param {*} formValues
   * @returns
   */
  validateOnHoldRequirement = (formValues: any) => {
    return !(!formValues.deactivateDate && formValues.reactivateDate);
  };

  /**
   * reactivate date must be later than deactivate date
   *
   * @param {*} formValues
   * @returns
   */
  validateOnHoldDiff = (formValues: any) => {
    if (formValues.deactivateDate && formValues.reactivateDate) {
      return moment(formValues.reactivateDate).isAfter(formValues.deactivateDate);
    }

    return true;
  };

  /**
   * Submit handler for current trade
   *
   * @param {*} formValues
   */
  handleSubmit = (formValues: any) => {
    const data = {
      ...this.props.currentTrade,
      ...formValues,
      // Convert dates to Date objects
      deactivateDate: (formValues.deactivateDate && moment(formValues.deactivateDate).toDate()) || null,
      reactivateDate: (formValues.reactivateDate && moment(formValues.reactivateDate).toDate()) || null
    };
    this.props.updateVendorTrade(this.props.vendorVM.id, data);
  };

  render() {
    return (
      <Form
        model={FormNames.VendorTradeMaintenance}
        hideNativeErrors={true}
        onSubmit={(formValues: any) => this.handleSubmit(formValues)}
        validators={{
          '': { onHoldUntilRequired: this.validateOnHoldRequirement, onHoldDiff: this.validateOnHoldDiff }
        }}
        validateOn="change"
      >
        <h2>Trade Overrides</h2>
        <div className="row">
          <div className="col-md-4 form-control">
            <label htmlFor={FormNames.VendorTradeMaintenance + '.hourlyAmountOverride'}>Hourly Override</label>
            <span className="fr">${this.props.vendorVM.hourlyRate}</span>
            <Control.text
              model={FormNames.VendorTradeMaintenance + '.hourlyAmountOverride'}
              min="0.00"
              step="0.01"
              type="number"
              validators={{ isDecimal }}
            />
            <Errors
              className="error"
              model=".hourlyAmountOverride"
              show={{ touched: true, focus: false }}
              messages={getDefaultErrorMessages()}
            />
          </div>
          <div className="col-md-4 form-control">
            <label htmlFor={FormNames.VendorTradeMaintenance + '.authorizedAmountOverride'}>
              Authorized Amount Override
            </label>
            <span className="fr">${this.props.vendorVM.authoLimit}</span>
            <Control.text
              model={FormNames.VendorTradeMaintenance + '.authorizedAmountOverride'}
              min="0.00"
              step="0.01"
              type="number"
              validators={{ isDecimal }}
            />
            <Errors
              className="error"
              model=".authorizedAmountOverride"
              show={{ touched: true, focus: false }}
              messages={getDefaultErrorMessages()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-control">
            <DateTimePicker
              formString={FormNames.VendorTradeMaintenance}
              modelString=".deactivateDate"
              label="On Hold From: "
            />
            <Errors
              className="error"
              model={FormNames.VendorTradeMaintenance}
              show={true}
              messages={getDefaultErrorMessages({
                onHoldUntilRequired: 'Must enter From and Until dates'
              })}
            />
          </div>
          <div className="col-md-4 form-control">
            <DateTimePicker
              formString={FormNames.VendorTradeMaintenance}
              modelString=".reactivateDate"
              label="On Hold Until: "
            />
            <Errors
              className="error"
              model={FormNames.VendorTradeMaintenance}
              show={true}
              messages={getDefaultErrorMessages({
                onHoldDiff: 'Until date must be later than From date'
              })}
            />
          </div>
        </div>
        <div className="row text-right">
          <div className="col-sm-12">
            <button className="btn btn-secondary pull-left" type="reset" onClick={() => this.reset}>
              Clear
            </button>
            <button className="btn btn-primary pull-right" type="submit">
              Save
            </button>
          </div>
        </div>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/_components/trade-overrides.component.tsx